import React, { Component } from "react";

import {
  CCard,
  CCardHeader,
  CButton,
  CLink,
  CCardFooter,
  CModal,
  CModalHeader,
  CModalBody,
  CModalTitle,
  CRow,
  CCol,
  CInput
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class SearchModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // loading: true,
      selectedUsers: [],
      // administrator: [
      //   { value: true, label: "Administrador" },
      //   { value: false, label: "Membro" }
      // ],
      // users: [],
      rooms: [],
      name: ""
    };
  }

  onOpen() {
    if (this.props.users) {
      const users = this.props.users.map(item => ({
        administrator: item.administrator,
        user: { id: item.id, name: item.user_name }
      }));
      this.setState({ selectedUsers: users });
    }
  }

  componentDidMount() {
    let requestRoute = `${URL.api}community/room/list?class=false&closed=false&group[]=null&region[]=null&school[]=null`;

    if (this.props.general.active_roles.group_id) {
      requestRoute += `&group[]=${this.props.general.active_roles.group_id}`;
    }

    if (this.props.general.active_roles.region_id) {
      requestRoute += `&region[]=${this.props.general.active_roles.region_id}`;
    }

    if (this.props.general.active_roles.school_id) {
      requestRoute += `&school[]=${this.props.general.active_roles.school_id}`;
    }

    axios
      .get(requestRoute, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          // eslint-disable-next-line react/no-unused-state
          this.setState({ rooms: resp.data.data, loading: false });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  addUser() {
    this.setState(state => {
      const prev = [...state.selectedUsers];
      prev.push({ user: { id: null }, administrator: null });

      return { selectedUsers: prev };
    });
  }

  removeUser(index) {
    this.setState(state => {
      let prev = [...state.selectedUsers];
      prev.splice(index, 1);

      return { selectedUsers: prev };
    });
  }

  changeUser(index, value) {
    this.setState(state => {
      let prev = [...state.selectedUsers];
      prev[index].user = value;

      return { selectedUsers: prev };
    });
  }

  changeAdministrator(index, value) {
    this.setState(state => {
      let prev = [...state.selectedUsers];
      prev[index].administrator = value;

      return { selectedUsers: prev };
    });
  }

  deleteRoomUser(roomUser) {
    axios
      .post(`${URL.api}community/room_user/delete/${roomUser}`, null, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.props.onUpdateRooms();
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  requestRoomUser(room, type) {
    const obj = {
      room_id: room,
      user_id: this.props.user.user.id,
      administrator: false,
      authorized: type === "open",
      request: true
    };

    axios
      .post(`${URL.api}community/room_user/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.props.onUpdateRooms();
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  render() {
    const filtered = this.state.rooms.filter(item =>
      item.name.toLowerCase().includes(this.state.name.toLowerCase())
    );
    return (
      <CModal
        show={this.props.show}
        size="lg"
        onClose={() => this.props.onClose()}
        onOpened={() => this.onOpen()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>Lista de Comunidades</CModalTitle>
        </CModalHeader>
        <CModalHeader>
          <CInput
            type="text"
            value={this.state.name}
            onChange={e => this.setState({ name: e.target.value })}
            placeholder="Digite o nome da comunidade"
            className="border-2 p-2 h-auto shadow-none border: 1px"
          />
        </CModalHeader>
        <CModalBody>
          <CRow>
            {filtered.length > 0 ? (
              filtered.map((room, idx) => {
                const roomUser = this.props.mine.find(
                  item => item.id === room.id
                );
                return (
                  <CCol sm="6" lg="4" key={idx} className="mb-3 mt-3">
                    <CCard className="card-room">
                      <CCardHeader
                        className="bg-primary d-flex justify-content-end flex-column"
                        style={{ height: 80 }}
                      >
                        <CLink to={`/room/${room.id}`} className="text-white">
                          <h4
                            className="card-title text-ellipsis m-0"
                            title={room.name}
                          >
                            {room.name}
                          </h4>
                        </CLink>
                      </CCardHeader>
                      <CCardFooter className="d-flex justify-content-between">
                        <span className="d-flex align-items-center text-muted">
                          <i className="fa fa-user mr-2"></i> {room.num_users}
                        </span>
                        {roomUser && roomUser.authorized ? (
                          <CButton
                            variant="outline"
                            color="danger"
                            onClick={() =>
                              this.deleteRoomUser(roomUser.room_user)
                            }
                          >
                            Sair
                          </CButton>
                        ) : roomUser && roomUser.request ? (
                          <CButton
                            color="secondary"
                            onClick={() =>
                              this.deleteRoomUser(roomUser.room_user)
                            }
                          >
                            Cancelar solicitação
                          </CButton>
                        ) : (
                          <CButton
                            color="primary"
                            onClick={() =>
                              this.requestRoomUser(room.id, room.type)
                            }
                          >
                            Entrar
                          </CButton>
                        )}
                      </CCardFooter>
                    </CCard>
                  </CCol>
                );
              })
            ) : (
              <div className="p-3 text-center w-100 text-muted">
                Nenhuma comunidade encontrada
              </div>
            )}
          </CRow>
        </CModalBody>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchModal);
